module.exports = __webpack_public_path__ + "static/media/placeholder.00d784cc.jpg";